import { render, staticRenderFns } from "./label-new.vue?vue&type=template&id=8bf47a08&"
import script from "./label-new.vue?vue&type=script&lang=js&"
export * from "./label-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bf47a08')) {
      api.createRecord('8bf47a08', component.options)
    } else {
      api.reload('8bf47a08', component.options)
    }
    module.hot.accept("./label-new.vue?vue&type=template&id=8bf47a08&", function () {
      api.rerender('8bf47a08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/base/vacancies/label-new.vue"
export default component.exports